<template>
    <div class="CAll">
        <!-- 头部导航  已更新样式-->
        <div class="top_section ">
            <div class="visible_area">
                <div class="logoAndtitle">
                    <div class="leftPart">
                        <img src="@/assets/img/logo.png" alt="" class="logo" @click="tabIndex">
                        <div class="descriptContent">
                            <div class="title">
                                建筑资质一站式采购平台
                            </div>
                            <div class="descript">
                                 <div>专业</div>
                                 <div>专注</div>
                                 <div>公开</div>
                                 <div>海量</div>
                            </div>
                        </div>
                    </div>


                    <div class="routers">
                        <!-- 搜索部分 -->
                        <transition name="search-fade">
                            <div class="searchInput" v-if="showSearch">
                                <div class="iptInnner">
                                    <el-cascader :options="provinceOptions" v-model="selectedData"
                                        @change="handleChange" class="citySelect"></el-cascader>

                                    <div class="fenge"></div>
                                    <div class="ipt_">
                                        <el-input class="ipt_input" type="text" placeholder="搜请输入关键字，例如资质名称"
                                            v-model="searchText" />
                                    </div>
                                    <div class="souBtn" @click="intSearch" ref="searchButton">立即搜索</div>
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>

                <div class="rightContent">

                    <!-- 我要发布按钮 -->
                    <transition name="search-fade">
                        <div class="pubBtn" v-if="showSearch || activeIndex !== '/index'" @click="handlePublishClick">
                            <img src="@/assets/img/addpub.png" alt="">
                            我要发布
                        </div>
                    </transition>

                    <div class="left_part">
                        <div class="bottomMess" v-if="!isLogin">
                            <img class="uimg" src="@/assets/img/usricon.png" alt="" style="width: 22px;height: 20px">
                            <span style="margin: 0 6px;" @click="setLogin">登录</span>
                            <span style="margin-right: 6px;">|</span>
                            <span @click="setLogin">注册</span>
                        </div>

                        <div class="bottomMess" v-if="isLogin">
                            <user-menu ref="someUse" :nav-opacity="navOpacity" />
                        </div>
                    </div>
                    <!-- <div class="right_part">
                        <img src="https://jzsc.mohurd.gov.cn/img/qrcode.a3861174.png" alt="">
                    </div> -->
                </div>
            </div>
        </div>

        <div class="emptyContent" v-if="activeIndex != '/index'"></div>


        <div>
            <keep-alive :include="['index', 'profile']">
                <router-view></router-view>
            </keep-alive>
        </div>

        <div class="footerContent">
            <!-- 上方 -->
            <div>
                <div class="footerLeft">
                    <div class="flogo">
                        <img src="@/assets/img/footlogo.png" alt="">
                    </div>
                    <div class="fphone">
                        Tel：17736086698
                    </div>
                    <div class="femail">
                        Email：657617474@qq.com
                    </div>
                </div>

                <div class="footerRight">
                    JIANQIHOME.COM
                </div>
            </div>
            <!-- 下方 -->
            <div>
                <div class="beianhao">
                    <img src="@/assets/img/gongan.png" alt="" style="margin-right: 6px;">
                    <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=13010202004434"
                        target="_blank">冀公网安备13010202004434号</a>
                    <a href="https://beian.miit.gov.cn/" target="_blank">冀ICP备2025136890号-1</a>
                    <span>Copyright© www.jianqihome.com版权所有</span>
                </div>

            </div>
        </div>
        <loginPopup v-if="showLoginPopup" ref="logonPopup"></loginPopup>

        <!-- 发布类型选择对话框 -->
        <PublishTypeDialog :visible="showPublishDialog" @close="showPublishDialog = false" />
    </div>
</template>

<script>
import loginPopup from '@/views/components/login.vue'
import UserMenu from '@/components/userMenu.vue'
import PublishTypeDialog from '@/components/PublishTypeDialog.vue'
import { getToken, removeToken } from '@/utils/auth';
import Cookies from "js-cookie";
let pcas = require("@/utils/china_address.json");
export default {
    data() {
        return {
            isLogin: false,
            showLoginPopup: false,
            activeIndex: '',
            recordNumber: '',
            showCashbackPopup: false,
            nickName: '',
            userAvatar: '/static/img/default-avatar.png',
            companyName: '河北嘉恒科技有限公司',
            isCertified: true,
            cities: pcas,
            selectedData: "0",
            selectedOptions: null, // 新增选中的城市
            // 用户统计数据
            publishCount: '128',
            visitCount: '1,284',
            pointsCount: '5,200',
            recommendCount: '42',
            searchText: '',
            provinceCode: '',
            showSearch: false, // 控制搜索框显示状态
            showPublish: false, // 控制"我要发布"按钮显示状态
            showPublishDialog: false, // 控制发布类型对话框显示状态
            navOpacity: 1 // 导航栏透明度，用于控制下拉三角颜色
        };
    },
    watch: {
        // 监听搜索关键词变化,同步到 Vuex
        searchText(newVal) {
            this.$store.commit('setSearchKeyword', newVal);
        },
        // 监听省份选择变化,同步到 Vuex
        selectedData(newVal) {
            this.$store.commit('setSelectedProvince', newVal);
        },
        // 监听 Vuex 中的搜索关键词变化,同步到本地
        '$store.state.searchKeyword'(newVal) {
            if (newVal !== this.searchText) {
                this.searchText = newVal;
            }
        },
        // 监听 Vuex 中的省份选择变化,同步到本地
        '$store.state.selectedProvince'(newVal) {
            if (newVal !== this.selectedData) {
                this.selectedData = newVal;
                // 同步更新 provinceCode
                if (newVal == "0") {
                    this.provinceCode = null;
                } else {
                    const province = this.cities.find(item => item && item.value === newVal);
                    this.provinceCode = province && province.short ? province.short : null;
                }
            }
        },
        // 监听 Vuex 中的 provinceCode 变化，同步到本地
        '$store.state.provinceCode'(newVal) {
            if (newVal !== this.provinceCode) {
                this.provinceCode = newVal;
            }
        },
        // 监听路由变化，立即更新导航栏样式
        activeIndex(newVal) {
            // 路由切换时立即调用 handleScroll 应用正确的样式
            this.$nextTick(() => {
                this.handleScroll();
            });
        }
    },

    computed: {
        // 只取一级（省）用于下拉
        provinceOptions() {
            const arr = Array.isArray(this.cities) ? this.cities : [];
            // 只取有效省份项
            const provinces = arr
                .filter((item) => item && item.value && item.label)
                .map((item) => ({
                    value: item.value,
                    label: item.label,
                }));
            // 在最前面新增“全部”选项
            provinces.unshift({
                value: "0",
                label: "全部",
            });
            return provinces;
        },
    },
    components: { loginPopup, UserMenu, PublishTypeDialog },
    mounted() {
        this.isLogin = getToken() ? true : false
        this.activeIndex = this.$route.path;
        this.nickName = Cookies.get('nickName')

        // 添加滚动事件监听
        window.addEventListener('scroll', this.handleScroll);
    },



    beforeDestroy() {
        // 移除滚动事件监听
        window.removeEventListener('scroll', this.handleScroll);
    },
    updated() {
        const that = this;
        const mypath = that.$route.path;
        if (mypath && mypath.length > 0) {
            that.activeIndex = mypath;
        }
    },

    methods: {
        //跳转路由
        goRouter(item) {
            this.$router.push(item.linkUrl);
            this.activeIndex = item.linkUrl;
        },
        handleChange(value) {
            // 当选择"全部"时，设置 selectedCode 为 null
            if (value[0] == "0") {
                this.provinceCode = null;
            } else {
                // 选择其他省份时，从原始 cities 数组中查找省份简称并赋值
                const province = this.cities.find(item => item && item.value === value[0]);
                this.provinceCode = province && province.short ? province.short : null;
            }
            // 同步到 Vuex - 只提交省份值，不提交整个数组
            this.$store.commit('setSelectedProvince', value[0]);
            // 同步 provinceCode 到 Vuex，确保与首页的 queryParams.provinceCode 保持同步
            this.$store.commit('setProvinceCode', this.provinceCode);
        },
        //同步
        intSearch() {
            // 同步搜索关键词到 Vuex
            this.$store.commit('setSearchKeyword', this.searchText);
            // 触发首页搜索
            this.$store.commit('setTriggerHomeSearch', true);
            // 自动滚动到615px位置
            this.$nextTick(() => {
                window.scrollTo({
                    top: 600,
                    behavior: 'smooth'
                });
            });
        },

        //点击客服
        gowechat() {
            this.centerWindow('https://work.weixin.com/kfid/kfc4425929bc602646e', 1000, 600);
        },
        //新窗口居中弹出
        centerWindow(url, width, height) {
            const screenLeft = (window.screen.width - width) / 2;
            const screenTop = (window.screen.height - height) / 2;
            window.open(url, '_blank', `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${width}, height=${height}, top=${screenTop}, left=${screenLeft}`);
        },
        //跳转个人中心
        tapUser() {
            this.$router.push('/personalCenter');
        },
        //退出登录
        tapLoginOut() {
            this.$confirm('是否确认退出登录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                removeToken();
                Cookies.remove('username');
                this.isLogin = false;
                localStorage.removeItem('AccessToken_expriesTime')
                location.href = '/index';
            }).catch(() => {
            });
        },
        tabIndex() {
            // this.$router.push('/index');
            window.location.href = '/index';
        },
        //点击客服
        tapServe() {
            // this.centerWindow('https://work.weixin.com/kfid/fc5363839f6', 1000, 600);
        },
        //新窗口居中弹出
        centerWindow(url, width, height) {
            const screenLeft = (window.screen.width - width) / 2;
            const screenTop = (window.screen.height - height) / 2;
            window.open(url, '_blank', `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${width}, height=${height}, top=${screenTop}, left=${screenLeft}`);
        },
        //打开推广返现弹框
        promotionCashback() {
            this.showCashbackPopup = true;
        },
        goUserDetail() {
            this.$router.push('/profile');
        },

        handlePublishClick() {
            if (this.isLogin) {
                this.showPublishDialog = true
            } else {
                this.setLogin()
            }
        },
        //设置登录
        setLogin() {
            // this.showLoginPopup = true;
            this.$router.push('/loginPage')
        },
        //打开注册
        openRege() {
            this.$router.push('/loginPage')
            // this.showLoginPopup = true;
            // this.$nextTick(() => {
            //     this.$refs.logonPopup.type = 2
            // })
        },
        // 滚动事件处理函数 - 实现导航栏逐渐变色效果
        handleScroll() {
            // 获取滚动距离
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

            // 获取顶部导航栏元素
            const topSection = document.querySelector('.top_section');

            if (topSection) {
                // 判断是否在index页面
                const isIndexPage = this.activeIndex === '/index';

                if (!isIndexPage) {
                    // 非index页面：直接显示白底、正常logo颜色、不显示搜索框
                    topSection.style.backgroundColor = 'rgba(255, 255, 255, 1)';
                    // topSection.style.boxShadow = '0px 4px 6px -4px rgba(0, 0, 0, 0.03), 0px 10px 15px -3px rgba(0, 0, 0, 0.03)';
                    this.showSearch = false;
                    this.navOpacity = 1; // 非首页导航栏不透明
                    topSection.style.color = '#000000 !important';

                    // logo显示正常颜色
                    const logo = topSection.querySelector('.logo');
                    if (logo) {
                        logo.style.filter = 'none';
                    }

                    // 登录注册字体显示为黑色
                    const loginTexts = topSection.querySelectorAll('.bottomMess');
                    loginTexts.forEach(text => {
                        text.style.color = '#000000';
                        const loginIcon = text.querySelector('.uimg');
                        if (loginIcon) {
                            loginIcon.style.filter = 'invert(100%) hue-rotate(180deg)';
                        }
                    });
                } else {
                    // index页面：保持原有的滚动渐变效果
                    // 计算透明度值
                    // 当滚动距离超过374px时，导航栏完全白色
                    const opacity = Math.min(scrollTop / 374, 1);
                    this.navOpacity = opacity; // 设置导航栏透明度
                    // 设置背景色，使用rgba实现渐变效果
                    topSection.style.backgroundColor = `rgba(255, 255, 255, ${opacity})`;

                    // 根据透明度值控制阴影效果的显示与隐藏
                    if (opacity >= 1) {
                        // topSection.style.boxShadow = '0px 4px 6px -4px rgba(0, 0, 0, 0.03), 0px 10px 15px -3px rgba(0, 0, 0, 0.03)';
                    } else {
                        topSection.style.boxShadow = 'none';
                    }

                    // 控制搜索框的显示与隐藏
                    this.showSearch = scrollTop >= 374;

                    // 当下拉大于40px时，修改logo和字体颜色为黑色
                    if (scrollTop > 150) {
                        // 修改logo为原色
                        const logo = topSection.querySelector('.logo');
                        if (logo) {
                            logo.style.filter = 'none';
                        }

                        // 修改登录注册字体为黑色
                        const loginTexts = topSection.querySelectorAll('.bottomMess');
                        loginTexts.forEach(text => {
                            text.style.color = '#000000';
                            // 修改登录图标为黑色
                            const loginIcon = text.querySelector('.uimg');
                            if (loginIcon) {
                                loginIcon.style.filter = 'invert(100%) hue-rotate(180deg)';
                            }
                        });

                        // 修改用户菜单昵称为黑色
                        const userName = topSection.querySelector('.user-name');
                        if (userName) {
                            userName.style.color = '#000000';
                        }
                    } else {
                        // 恢复logo滤镜
                        const logo = topSection.querySelector('.logo');
                        if (logo) {
                            logo.style.filter = 'brightness(0) invert(1)';
                        }

                        // 恢复登录注册字体颜色
                        const loginTexts = topSection.querySelectorAll('.bottomMess');
                        loginTexts.forEach(text => {
                            text.style.color = '#ffffff';
                            // 恢复登录图标为白色
                            const loginIcon = text.querySelector('.uimg');
                            if (loginIcon) {
                                loginIcon.style.filter = 'brightness(0) invert(1)';
                            }
                        });

                        // 恢复用户菜单昵称为白色
                        const userName = topSection.querySelector('.user-name');
                        if (userName) {
                            userName.style.color = '#ffffff';
                        }
                    }
                }
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.CAll {
    min-width: 1280px;
    // background-color: #F9FAFB;
      background-color: #EFF1F3;

    
}

.top_section {
    position: fixed;
    z-index: 4;
    top: 0;
    left: 0;
    width: 100%;
    height: 70px;

    .visible_area {
        width: 1280px;
        height: 100%;
        margin: 0 auto;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .logoAndtitle {
            display: flex;
            align-items: center;
            width: calc(100% - 260px);
            height: 100%;
            justify-content: space-between;
            padding-right: 25px;

            .leftPart {
                display: flex;
                align-items: center;
                height: 100%;
                width: 345px;
                justify-content: space-between;
            }

            .logo {
                width: 152px;
                height: 44px;
                display: flex;
                align-items: center;
                font-size: 30px;
                justify-content: space-between;
                cursor: pointer;
                filter: brightness(0) invert(1);
                // 移除过渡效果，让logo直接变为原色

                img {
                    width: 100%;
                    height: 44px;
                }
            }

            .descriptContent {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                width: 177px;
                height: 40px;
                font-size: 12px;
                color: #ffffff;
                background-color: #E77741;
                white-space: nowrap;
                margin-left: 14px;
                text-align: center;
                  .title{
                        //字间距
                        letter-spacing: 3px;
                    }
                .descript{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    letter-spacing: 4px;
                  
                    
                    >div{
                         margin-right: 7px;
                    }
                    >div:last-child{
                        margin-right: 0;
                    }
                
                }

            }

            .routers {
                display: flex;
                align-items: center;
                margin-left: 17px;
                box-sizing: border-box;
                font-size: 14px;
                // width: calc(100% - 180px);
                // margin-left: 50px;
                padding-right: 63px;
                justify-content: space-between;

                .searchInput {
                    width: 487px;
                    height: 40px;
                    border-radius: 8px;
                    // margin: 0 auto;
                    background: #EFF1F3;
                    z-index: 2;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    .iptInnner {
                        width: 100%;
                        height: 40px;
                        background: #EFF1F3;

                        box-sizing: border-box;
                        display: flex;
                        justify-content: space-between;
                        align-content: center;

                        .citySelect {
                            width: 100px;
                            height: 100%;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 14px;

                            .imgClass {
                                width: 14px;
                                height: 8px;
                                margin-left: 10px;
                            }
                        }



                        .citySelect :deep(.el-input__inner) {
                            border: none;
                            outline: none;
                            background: transparent;
                            text-align: center;
                            font-size: 14px;
                        }


                        .citySelect ::v-deep .el-input__suffix {
                            display: flex;
                            align-items: center;
                        }

                        // 覆盖 el-cascader 的下拉图标颜色为黄色
                        .citySelect ::v-deep .el-input__icon {
                            color: #0251AE !important; // 明亮黄色
                            position: relative;
                            left: -4px;
                            font-size: 0;
                            /* 隐藏默认图标 */
                            width: 20px;
                            /* 设置固定宽度 */
                            height: 20px;
                            /* 设置固定高度 */
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }

                        // 自定义三角样式箭头
                        .citySelect ::v-deep .el-input__icon::before {
                            content: '';
                            width: 0;
                            height: 0;
                            border-left: 5px solid transparent;
                            border-right: 5px solid transparent;
                            border-top: 5px solid #0251AE;
                            font-size: 0;
                            line-height: 0;
                            display: inline-block;
                            transition: transform 0.3s ease;
                            /* 添加过渡效果 */
                            transform-origin: center center;
                            /* 设置变换原点为中心 */
                        }

                        // 展开时箭头翻转
                        .citySelect ::v-deep .el-cascader.is-opened .el-input__icon::before {
                            transform: rotate(180deg);
                        }


                        .ipt_input :deep(.el-input__wrapper) {
                            border: none !important;
                            box-shadow: none !important;
                            background: transparent !important;
                            padding: 0 !important;
                            height: 100%;

                        }

                        .ipt_input :deep(.el-input__inner) {
                            width: 100%;
                            height: 100%;
                            padding: 0;
                            border: none;
                            outline: none;
                            padding-left: 30px;
                            box-sizing: border-box;
                            background: transparent;
                        }

                        .fenge {
                            height: 20px;
                            width: 1px;
                            background: #0251AE;
                            margin-top: 10px;
                        }

                        .ipt_ {
                            height: 100%;
                            width: calc(100% - 191px);

                            .ipt_input {
                                height: 100%;
                                width: 100%;
                                color: black;
                                box-sizing: border-box;
                            }
                        }

                        .souBtn {
                            width: 104px;
                            height: 40px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            background: #E77741;
                            font-size: 14px;
                            color: white !important;
                            cursor: pointer;
                        }
                    }
                }
            }
        }

        .rightContent {
            width: 260px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            height: 100%;
            font-size: 14px;
            cursor: pointer;
            position: relative;

            .left_part {
                display: flex;
                align-items: center;

                .bottomMess {
                    display: flex;
                    align-items: center;

                    img {}

                    span {
                        // transition: color 0.3s ease;
                    }
                }

                .right_part {
                    width: 65px;
                    height: 65px;
                    // background-color: gray;
                    margin-left: 20px;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .bottomMess {
                    position: relative;
                }
            }
        }

        .pubBtn {
            width: 100px;
            margin-right: 10px;
            font-size: 14px;
            color: #E77741 !important;
            text-align: left;
            font-style: normal;
            display: flex;
            align-items: center;
            cursor: pointer;
            float: left;
            position: absolute;
            left: 0;

            img {
                width: 24px;
                height: 24px;
                margin-right: 4px;
            }
        }


        .wxLogin {
            display: flex;
            width: 140px;
            height: 40px;
            border-radius: 25px;
            background-color: #2f499d;
            font-size: 14px;
            color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            >img {
                width: 16px;
                height: 16px;
                margin-right: 10px;
            }
        }

        .wxloginuser {
            font-size: 14px;
            cursor: pointer;
            white-space: nowrap;


            span:nth-child(2) {
                margin: 0 2px;
            }
        }

        .loginBtn,
        .regBtn {}
    }
}

// 移除动画相关代码，使用过渡效果
.whiteContent {
    // background: #fff;
    background-color: rgba(255, 255, 255, 1);
    // box-shadow: 0px 4px 6px -4px rgba(0, 0, 0, 0.1), 0px 10px 15px -3px rgba(0, 0, 0, 0.1);

    .routers {
        >div {
            color: #000000;
        }
    }

    .logo {
        color: #000000;

        img {
            filter: none !important;
        }
    }

    .wxloginuser {
        color: #000000 !important;
    }
}

// 为.top_section添加过渡效果
.top_section {
    transition: background-color 0.4s ease;
    background-color: rgba(255, 255, 255, 0);
}

.emptyContent {
    height: 70px;
}

.footerContent {
    width: 100%;
    background-color: #1B2331;
    position: relative;
    color: white;
    height: 248px;
    min-width: 1280px;
    box-sizing: border-box;

    >div:nth-child(1) {
        width: 1280px;
        display: flex;
        height: 160px;
        margin: 0 auto;

        justify-content: space-between;

        .footerLeft {
            display: flex;
            align-items: center;

            .flogo {
                width: 152px;
                height: 44px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .fphone {
                font-size: 14px;
                color: #8E9299;
                font-style: normal;
                margin-left: 70px;
            }

            .femail {
                font-size: 14px;
                color: #8E9299;
                font-style: normal;
                margin-left: 25px;
            }
        }

        .footerRight {
            width: 500px;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            font-weight: 900;
            font-size: 52px;
            color: #313845;
            line-height: 73px;
            font-style: normal;
        }
    }

    .beianhao {
        background-color: #181F2C;
        height: 87px;
        width: 100%;
        min-width: 1280px;
        margin: 0 auto;
        font-size: 14px;
        font-size: 12px;
        color: #525A67;
        line-height: 16px;
        text-align: center;
        font-style: normal;
        display: flex;
        align-items: center;
        justify-content: center;

        a {
            color: #525A67;
            margin-right: 10px;
            text-decoration: none;
        }

        img {
            width: 15px;
            height: 15px;
        }
    }


}

.menuList {
    display: flex;
    width: 1000px;
    margin: 0 auto;
    justify-content: center;

    span {
        font-size: 16px;
        color: black;
        margin: 10px 0;
        display: block;
        margin-top: 30px;
        margin-bottom: 20px;
        text-align: left;
    }

    ul {
        font-size: 13px;
        text-align: left;
        margin: 0;
        padding: 0;
        display: flex;
        min-width: 280px;
        flex-wrap: wrap;
    }

    li {
        list-style-type: none;
        text-align: left;
        font-size: 14px;
        padding: 0px 10px 15px 0;
        color: black;
        cursor: pointer;
        margin-right: 20px;
        min-width: 80px;
        white-space: nowrap;
    }

    li:hover {
        color: #2d8cf0 !important;
    }

    .compMessage {
        text-align: left;
        margin-left: 100px;

        span {
            font-size: 16px;
            color: black;
            margin: 10px 0;
            display: block;
            margin-top: 30px;
            margin-bottom: 20px;
        }

        div {
            font-size: 14px;
            color: black;
            margin-bottom: 15px;
        }
    }
}
</style>